// Chapitre « Je m'entraîne » : saisie, progression, Gym'Coach, partenaires.
import React from "react";
import Rangee from "./Rangee";
import { IconeHaltere } from "../../site/Icones";
import ApercuSeance from "../../site/apercus/ApercuSeance";
import ApercuSerie from "../../site/apercus/ApercuSerie";
import ApercuCourbe1RM from "../../site/apercus/ApercuCourbe1RM";
import ApercuFicheGymCoach from "../../site/apercus/ApercuFicheGymCoach";
import ApercuPublication from "../../site/apercus/ApercuPublication";

export default function ChapitreSportif() {
	return (
		<section className="gs-section" id="fonctionnalites" aria-labelledby="gs-chap-sportif">
			<div className="gs-quadrillage gs-quadrillage--section" />
			<div className="gs-conteneur">
				<div className="gs-tete-section">
					<span className="gs-repere">
						<i>
							<IconeHaltere taille={18} />
						</i>
						Je m'entraîne
					</span>
					<h2 id="gs-chap-sportif" className="gs-h2">
						Ton carnet, <span className="gs-accent">en plus intelligent.</span>
					</h2>
					<p className="gs-texte gs-texte--grand">
						Tout ce que tu notais sur papier, plus ce que le papier ne savait pas faire : comparer, prévoir,
						encourager.
					</p>
				</div>

				<Rangee
					surtitre="Saisie"
					titre="Note ta séance en deux minutes"
					texte="Tes charges de la dernière fois sont déjà là : tu confirmes, tu ajustes, tu passes à la série suivante. Le minuteur de repos démarre tout seul."
					points={[
						"Fonctionne hors ligne, synchronisé dès que le réseau revient",
						"Bibliothèque d'exercices avec pictogrammes",
						"Supersets et échauffements",
					]}
				>
					<ApercuSeance />
				</Rangee>

				<Rangee
					inverse
					surtitre="Progression"
					titre="Chaque série te dit si tu progresses"
					texte="GymNote compare chaque série à la même série de ta séance précédente, au 1RM estimé, reps en réserve comprises. Quand tu avances, tu le vois tout de suite."
					points={[
						"Badge « Progression » série par série",
						"Courbe du 1RM estimé pour chaque exercice",
						"Records détectés et fêtés automatiquement",
					]}
				>
					<div className="gs-a-pile">
						<ApercuSerie avecSuivante={false} />
						<ApercuCourbe1RM />
					</div>
				</Rangee>

				<Rangee
					surtitre="Gym'Coach"
					titre="Gym'Coach prépare ta prochaine séance"
					texte="Avant chaque séance, Gym'Coach lit ton historique et propose un objectif pour chaque série. Un tap, et ta séance est préremplie."
					points={[
						"Objectif par série : reps, charge et RPE",
						"Les consignes de ton coach passent en priorité",
						"Inclus dans GymNote+",
					]}
				>
					<ApercuFicheGymCoach />
				</Rangee>

				<Rangee
					inverse
					surtitre="Partenaires"
					titre="Tes partenaires te poussent"
					texte="Partage une série, réagis aux records de tes amis, commente une perf. La motivation tient entre deux séances."
					points={[
						"Réactions et commentaires sur chaque série",
						"Fil d'actu de tes partenaires",
						"Tes séries partagées en image",
					]}
				>
					<ApercuPublication />
				</Rangee>
			</div>
		</section>
	);
}
